/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Tab_EmptyInputs */

const en_media_tab_empty = /** @type {(inputs: Media_Tab_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No media versions imported yet.`)
};

const fr_media_tab_empty = /** @type {(inputs: Media_Tab_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune version multimédia n'a encore été importée.`)
};

const de_media_tab_empty = /** @type {(inputs: Media_Tab_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es wurden noch keine Medienversionen importiert.`)
};

const it_media_tab_empty = /** @type {(inputs: Media_Tab_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna versione multimediale è stata ancora importata.`)
};

const ru_media_tab_empty = /** @type {(inputs: Media_Tab_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пока не импортированы никакие версии медиафайлов.`)
};

const es_media_tab_empty = /** @type {(inputs: Media_Tab_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no se han importado versiones multimedia.`)
};

const zh_cn2_media_tab_empty = /** @type {(inputs: Media_Tab_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未导入任何媒体版本。`)
};

const ja_media_tab_empty = /** @type {(inputs: Media_Tab_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアバージョンはまだインポートされていません。`)
};

const hi_media_tab_empty = /** @type {(inputs: Media_Tab_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी तक कोई मीडिया संस्करण आयात नहीं किया गया है।`)
};

const pt_pt2_media_tab_empty = /** @type {(inputs: Media_Tab_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma versão de mídia foi importada ainda.`)
};

/**
* | output |
* | --- |
* | "No media versions imported yet." |
*
* @param {Media_Tab_EmptyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_tab_empty = /** @type {((inputs?: Media_Tab_EmptyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Tab_EmptyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_tab_empty(inputs)
	if (locale === "de") return de_media_tab_empty(inputs)
	if (locale === "it") return it_media_tab_empty(inputs)
	if (locale === "ru") return ru_media_tab_empty(inputs)
	if (locale === "es") return es_media_tab_empty(inputs)
	if (locale === "zh-CN") return zh_cn2_media_tab_empty(inputs)
	if (locale === "ja") return ja_media_tab_empty(inputs)
	if (locale === "hi") return hi_media_tab_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_media_tab_empty(inputs)
	return en_media_tab_empty(inputs)
});